import { render, staticRenderFns } from "./defaultVisualSection.vue?vue&type=template&id=b422017c&scoped=true"
import script from "./defaultVisualSection.vue?vue&type=script&lang=ts"
export * from "./defaultVisualSection.vue?vue&type=script&lang=ts"
import style0 from "./defaultVisualSection.vue?vue&type=style&index=0&id=b422017c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b422017c",
  null
  
)

export default component.exports